import isEmpty from 'lodash/isEmpty';
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './TaxonomyLookupModalFooter.scss';

function TaxonomyLookupModalFooter({ clearSelected, opModel, applyChanges, transferEnabled }) {
  return (
    <div className="taxonomyLookupModal__footer">
      <div className="taxonomyLookupModal__footer_buttons">
        <ButtonWithIcon
          data-e2e="taxonomyLookupModal-footer-clear"
          type="link"
          size="small"
          sprite="Close"
          linkIconSize="s"
          iconRight
          disabled={isEmpty(opModel.selection)}
          aria-disabled={isEmpty(opModel.selection)}
          aria-label="Clear selected"
          onClick={clearSelected}
          className="e2e-taxonomyLookupModal-footer-clear">
          Clear selected
        </ButtonWithIcon>
        <ButtonWithIcon
          data-e2e="taxonomyLookupModal-footer-transfer"
          type="primary"
          size="small"
          sprite="ChevronRight"
          linkIconSize="s"
          iconRight
          disabled={isEmpty(opModel.selection) && !transferEnabled}
          aria-disabled={isEmpty(opModel.selection) && !transferEnabled}
          aria-label="Transfer"
          onClick={applyChanges}
          className="e2e-taxonomyLookupModal-footer-transfer">
          Transfer
        </ButtonWithIcon>
      </div>
    </div>
  );
}

TaxonomyLookupModalFooter.propTypes = {
  opModel: PropTypes.object,
  transferEnabled: PropTypes.bool,
  clearSelected: PropTypes.func.isRequired,
  applyChanges: PropTypes.func.isRequired,
};

export default TaxonomyLookupModalFooter;
